/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import DatePicker from "react-flatpickr";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { v4 as uuidV4 } from "uuid";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import SoftTypography from "components/SoftTypography";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};
const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  whiteSpace: "nowrap",
};
const selectStyle = {
  minWidth: 200,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
};
const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

export default function Table13({ formData, setFieldValue }) {
  const [data, setData] = useState([
    {
      id: uuidV4(),
      typeSpending: "",
      spending: "",
      taxId: "",
      province: "",
      district: "",
      cqt: "",
      tax7: 0,
      tax8: 0,
      tax9: 0,
      tax10: 0,
      tax11: 0,
      tax12: 0,
      tax13: 0,
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);
  const handleChange = (values) => {
    const { id, name, value, type } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data });
  };
  const handleChangeDate = (date, id) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd = () => {
    setData((prev) => [
      ...prev,
      {
        id: uuidV4(),
        typeSpending: "",
        spending: "",
        taxId: "",
        province: "",
        district: "",
        cqt: "",
        tax7: 0,
        tax8: 0,
        tax9: 0,
        tax10: 0,
        tax11: 0,
        tax12: 0,
        tax13: 0,
      },
    ]);
  };
  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={2}
                style={{ textAlign: "center", minWidth: 10 }}
              >
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 200 }}>
                Loại chi tiêu
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 200 }}>
                Chi tiêu
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Mã số thuế/Mã địa điểm kinh doanh
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Địa bàn hoạt động sản xuất, kinh doanh
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Cơ quan thuế quản lý địa bàn nhận phân bố
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Xác định tỷ lệ phân bố
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số thuế TNDN phải nộp
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số thuế TNDN nộp thừa kỳ trước chuyển sang kỳ này
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số thuế TNDN nộp đã tạm nộp
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Chênh lệch giữa số thuế phải nộp và số thuế đã tạm nộp trong năm
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số thuế TNDN còn phải nộp
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>Tỉnh</Td>
              <Td style={{ textAlign: "center" }}>Huyện</Td>
              <Td style={{ textAlign: "center" }}>Chi phí của cơ sở sản xuất</Td>
              <Td style={{ textAlign: "center" }}>Tỷ lệ phân bố</Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>(1)</Td>
              <Td style={{ textAlign: "center" }}></Td>
              <Td style={{ textAlign: "center" }}>(2)</Td>
              <Td style={{ textAlign: "center" }}>(3)</Td>
              <Td style={{ textAlign: "center" }}>(4)</Td>
              <Td style={{ textAlign: "center" }}>(5)</Td>
              <Td style={{ textAlign: "center" }}>(6)</Td>
              <Td style={{ textAlign: "center" }}>(7)</Td>
              <Td style={{ textAlign: "center" }}>(8)=(7)/[05]</Td>
              <Td style={{ textAlign: "center" }}>(9)=(8)x[04]</Td>
              <Td style={{ textAlign: "center" }}>(10)</Td>
              <Td style={{ textAlign: "center" }}>(11)</Td>
              <Td style={{ textAlign: "center" }}>(12)=(9)-(11)</Td>
              <Td style={{ textAlign: "center" }}>(13)=(9)-(10)-(11)</Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "typeSpending", e.target.value)}
                  >
                    <option value="value1">Tỉnh nơi đóng trụ sở chính</option>
                    <option value="value2">
                      Cơ sở sản xuất khác tỉnh (trừ nhà máy thủy điện nằm trên nhiều tỉnh)
                    </option>
                    <option value="value3">
                      Cơ sở sản xuất khác tỉnh là nhà máy thủy điện nằm trên nhiều tỉnh
                    </option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="spending"
                    value={item.spending}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="taxId"
                    value={item.taxId}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "province", e.target.value)}
                  >
                    <option value="value1">Tỉnh A</option>
                    <option value="value2">Tỉnh B</option>
                    <option value="value3">Tỉnh C</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "district", e.target.value)}
                  >
                    <option value="value1">Huyện A</option>
                    <option value="value2">Huyện B</option>
                    <option value="value3">Huyện C</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "cqt", e.target.value)}
                  >
                    <option value="value1">Cơ quan thuế A</option>
                    <option value="value2">Cơ quan thuế B</option>
                    <option value="value3">Cơ quan thuế C</option>
                  </select>
                </Td>
                <Td>
                  <InputTable id={item.id} name="tax7" value={item.tax7} onChange={handleChange} />
                </Td>
                <Td>
                  <InputTable id={item.id} name="tax8" value={item.tax8} onChange={handleChange} />
                </Td>
                <Td>
                  <InputTable id={item.id} name="tax9" value={item.tax9} onChange={handleChange} />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="tax10"
                    value={item.tax10}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="tax11"
                    value={item.tax11}
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  style={{
                    background: "#ddeff3",
                    textAlign: "center",
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  <InputTable
                    id={item.id}
                    name="tax12"
                    value={item.tax12}
                    onChange={handleChange}
                    readOnlyBackground={true}
                    readOnly={true}
                    fontWeight="bold"
                  />
                </Td>
                <Td
                  style={{
                    background: "#ddeff3",
                    textAlign: "center",
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  <InputTable
                    id={item.id}
                    name="tax13"
                    value={item.tax13}
                    onChange={handleChange}
                    readOnlyBackground={true}
                    readOnly={true}
                    fontWeight="bold"
                  />
                </Td>
              </tr>
            ))}
            <tr key={1000}>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
                colSpan={3}
              >
                Tổng cộng:
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>{" "}
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>{" "}
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>{" "}
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  fontWeight={"bold"}
                  value={0}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  fontWeight={"bold"}
                  value={0}
                />
              </Td>{" "}
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>{" "}
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>{" "}
            </tr>
          </tbody>
        </table>
      </Box>
      <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
        <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </SoftBox>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, readOnlyBackground, fontWeight, type = "text", ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      style={{
        textAlign: "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: readOnlyBackground === true ? "#ddeff3" : "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        fontWeight: fontWeight,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
